var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-select',{attrs:{"search":"","label":_vm.Label,"placeholder":_vm.Placeholder,"visibleOptions":5},on:{"getValue":_vm.getSelectValue},model:{value:(_vm.List),callback:function ($$v) {_vm.List=$$v},expression:"List"}})
}
var staticRenderFns = []

export { render, staticRenderFns }